<div>
  {{'assignmentManagement.code' | translate}}: <code *ngIf="!showSpinner && code">{{code}}</code>
  <app-spinner *ngIf="showSpinner" [strokeWidth]="2" [diameter]="25"></app-spinner>
</div>
